
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class xxx extends Vue {
  name = '测试'
  // 创建时触发
  created() {}
  // 挂载成功出发
  mounted() {}
}
